export default __webpack_public_path__ + "static/contractor-supplier-mobile-banner-137143eb3fd7c1a9b3e6ce345f9ce29f.png";